import { AppBar, Box, Toolbar, Typography } from '@mui/material'
import React from 'react'
import LogoMarkNeighborly from '../../assets/webp/neighborly-header-logo.webp'
import LogoCadsoftPrimary from '../../assets/svg/logo-cadsoft-primary.svg'
import LogoLinesBlack from '../../assets/svg/logo-lines-black.svg'

const Header = (props) => {
  return (
    <AppBar position="static" sx={{backgroundColor: "#ffffff", mb: .25,}}>
      <Toolbar sx={{backgroundColor: "#ffffff", display: "flex", flex: 1, justifyContent: "center",}}>
        <Box sx={{display: "flex", flex: 1, justifyContent: "center", alignItems: "center", flexDirection: "row",}}>
          <Box
            component="img"
            src={LogoCadsoftPrimary} width={props. windowSize.width > 768 ? 140 : 140 / 1.5 } height={props.windowSize.width > 768 ? 40 : 40 / 1.5 }
          />
          <Typography color="black" fontSize={10} sx={{mx: 2}}>×</Typography>
          <Box
            component="img"
            src={LogoLinesBlack} width={props.windowSize.width > 768 ? 121 : 121 / 1.5 } height={props.windowSize.width > 768 ? 20 : 20 / 1.5 }
          />
          <Typography color="black" fontSize={10} sx={{mx: 2}}>FOR</Typography>
          <Box
            component="img"
            src={LogoMarkNeighborly} height={props.windowSize.width > 768 ? 29 : 29 / 1.5 } width={props.windowSize.width > 768 ? 135 : 135 / 1.5 }
            sx={{mt: .5,}}
          />
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default Header